export interface AutoscrollHoldState {
  playing: boolean
  /** Note composers open right now. */
  holds: number
  /** Autoscroll was running when the first composer opened: closing the last one resumes it. */
  resume: boolean
}

export type AutoscrollHoldAction = { type: 'toggle' } | { type: 'stop' } | { type: 'hold' } | { type: 'release' }

export const initialAutoscrollHold: AutoscrollHoldState = { playing: false, holds: 0, resume: false }

/**
 * Autoscroll, paused while the performer writes a note (spec 2026-10-14): opening any composer pauses it,
 * and closing the last one resumes it if it was running. Play or pause by hand while writing wins.
 */
export const autoscrollHold = (state: AutoscrollHoldState, action: AutoscrollHoldAction): AutoscrollHoldState => {
  switch (action.type) {
    case 'toggle':
      return { ...state, playing: !state.playing, resume: false }
    case 'stop':
      return { ...state, playing: false, resume: false }
    case 'hold':
      return state.holds === 0 && state.playing
        ? { playing: false, holds: 1, resume: true }
        : { ...state, holds: state.holds + 1 }
    case 'release': {
      const holds = Math.max(0, state.holds - 1)
      return holds > 0 ? { ...state, holds } : { playing: state.playing || state.resume, holds: 0, resume: false }
    }
  }
}
